import { render, staticRenderFns } from "./VoucherIndex.vue?vue&type=template&id=70defede&scoped=true"
import script from "./VoucherIndex.vue?vue&type=script&lang=js"
export * from "./VoucherIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70defede",
  null
  
)

export default component.exports